<template>
    <div v-if="isSuperAdmin">
        <LaPageHeader heading="Import log"> </LaPageHeader>

        <LaContentLoader v-if="loading" />

        <div v-else>
            <LaNoData v-if="!hasData" header="No import logs" description="Couldn't load any import log data.">
            </LaNoData>
            <div v-else>
                <div class="columns">
                    <div class="column">
                        <LaImportLogTable :data="importLogs" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LaPageHeader from "@/components/PageHeader";
import LaContentLoader from "@/components/loaders/ContentLoader";
import LaNoData from "@/components/NoData";
import LaImportLogTable from "@/components/import-log/ImportLogTable.vue";
import store from "@/store/store";
import { computed } from "vue";
import { actionTypes as importLogActionTypes, getterTypes as importLogGetterTypes } from "@/store/ImportLog/types";
import { getterTypes as loggedUserGetterTypes } from "@/store/LoggedUser/types";

export default {
    name: "LaImportLogView",
    components: {
        LaPageHeader,
        LaContentLoader,
        LaNoData,
        LaImportLogTable,
    },

    setup() {
        const userRights = computed(() => store.getters[loggedUserGetterTypes.getUserRights]);
        const isSuperAdmin = computed(() => userRights.value && userRights.value["super_admin"]);

        const loading = computed(() => store.getters[importLogGetterTypes.isLoading]);
        const importLogs = computed(() => store.getters[importLogGetterTypes.getImportLogs]);
        const hasData = computed(() => !!importLogs.value);

        store.dispatch(importLogActionTypes.getData);

        return {
            isSuperAdmin,
            loading,
            hasData,
            importLogs,
        };
    },
};
</script>
